/**
 * 旧パラメータから新パラメータを返す
 * @param querys
 * @param oldValueList
 * @returns
 */
export const toNewQueryValue = (
  querys: string | string[] | undefined,
  oldValueList: string[]
) => {
  if (!querys) return undefined;

  if (Array.isArray(querys)) {
    const newQueryValueList = querys
      .map((query) =>
        String(oldValueList.findIndex((item) => item === query) + 1)
      )
      .filter((item) => item !== '0');

    return newQueryValueList.length ? newQueryValueList : undefined;
  }

  const newQueryValue = oldValueList.findIndex((item) => item === querys) + 1;
  return newQueryValue ? String(newQueryValue) : undefined;
};
